import { CircularProgress, IconButton } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { Modal } from 'react-bootstrap';
import CountdownTimer from './components/Helpers/Time/CountdownTimer';
import { httpRequest } from './httpRequest';

export default function SessionTimeout(props) {

  const { extendSessionCallback, sessionTimeoutPeriod } = props;

  const [modalActive, setModalActive] = useState(false);
  const [loading, setLoading] = useState(false);

  const allowSessionExtension = useRef(true);

  let lastCheckTime = 0;
  let checkFrequencyMS = 1000 * 60 * 5; 

  let notifyEvent;
  let notifyTimeMS = 1000 * 60 * (Number(sessionTimeoutPeriod) - 5);  // notify 5 min prior to timeout 

  const userActivityEvents = [
    'click',
    'keypress',
    'load',
    'focus',
    'keydown'
  ];

  useEffect(() => {
    // configure listener events 
    userActivityEvents.forEach(event => {
      window.addEventListener(event, sessionTimeout);
    });

    notifyEvent = setTimeout(() => {
      setModalActive(true);
      allowSessionExtension.current = false;
    }, notifyTimeMS);
  }, []);

  const sessionTimeout = () => {
    if ((lastCheckTime >= Date.now() - checkFrequencyMS) || !allowSessionExtension.current) {
      return;
    }

    lastCheckTime = Date.now();

    if (!!notifyEvent) clearTimeout(notifyEvent);

    notifyEvent = setTimeout(() => {
      setModalActive(true);
      allowSessionExtension.current = false;
    }, notifyTimeMS);

    extendTimeout();
  };

  const logOut = () => {
    setModalActive(false);
    window.location.href = "/logOut";
  }

  const extendTimeout = async () => {
    setLoading(true);

    try {
      const sessionData = await httpRequest.get('/SSO/ExtendSession');
      extendSessionCallback(sessionData);
      setModalActive(false);
      setLoading(false);
      allowSessionExtension.current = true;
    }
    catch (err) {
      setModalActive(false);
      setLoading(false);
      console.log(err);
    }
  };

  return (
    <React.Fragment>
      <Modal className="insured-info-content" show={modalActive} animation={false} backdrop="static" onHide={() => setModalActive(false)} centered>
        <Modal.Body className="d-flex align-items-center justify-content-center p-3 flex-column">
          <div className="head-close">
            <IconButton className="close-button" aria-label="close" onClick={() => setModalActive(false)}>
              <CloseIcon />
            </IconButton>
          </div>
          <p className="pb-4 pt-2 text-center insured-info">Your session is about to Expire. If you do not extend your session within 5 minutes, any unsaved progress will be lost.</p>
          <CountdownTimer initialMinute={5} onTimerComplete={() => logOut()} />
          {
            loading ? <CircularProgress className="circular-progress" /> :
              <Button className="text-center px-4 w-25"
                variant="contained"
                size="medium"
                color="primary"
                onClick={() => extendTimeout()}
              >
                Extend
              </Button>
          }
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}

SessionTimeout.propTypes = {
  extendSessionCallback: PropTypes.func.isRequired,
  sessionTimeoutPeriod: PropTypes.string.isRequired
}



// WEBPACK FOOTER //
// ./src/SessionTimeout.js